// permissions.js

const portingAccessEnabled = {
  id: 'portingAccessEnabled',
  label: 'Carrier Hub: Porting',
};

const realTimeActivityEnabled = {
  id: 'realTimeActivityEnabled',
  label: 'PCAP Analyzer',
};

const dataCenterMonitor = {
  id: 'dataCenterMonitor',
  label: 'Data Center Monitor',
};

const epikPlatform = {
  id: 'epikPlatform',
  label: 'EPIK Monitoring Services',
};

const numberCarrierChangeAccess = {
  id: 'numberCarrierChangeAccess',
  label: 'Carrier Access',
};

const warehouseQcAccess = {
  id: 'warehouseQcAccess',
  label: 'Warehouse QC Wizard',
};

const nocWizardAccess = {
  id: 'nocWizardAccess',
  label: 'NOC Wizard',
};

const numberBulkActionsAccess = {
  id: 'numberBulkActionsAccess',
  label: 'Bulk Number Action',
};

const eth3Access = {
  id: 'eth3Access',
  label: 'Eth0/3 Disable',
};

const phoneAccess = {
  id: 'phoneAccess',
  label: 'IP Phone Management',
};

const pcapModulePermission = {
  id: 'pcapModulePermission',
  label: 'PCAP Lookup',
};

const internationalDialingAccess = {
  id: 'internationalDialingAccess',
  label: 'International Dialing',
};

const outBandManagement = {
  id: 'outBandManagement',
  label: 'OOBM Access',
};

const portConfigurationAccess = {
  id: 'portConfigurationAccess',
  label: 'Port Configuration management',
};

const ttyOptionsAccess = {
  id: 'ttyOptionsAccess',
  label: 'TTY Access Management',
};

const docToolAccess = {
  id: 'docToolAccess',
  label: 'Documentation Tool',
};

const recDiagnostics = {
  id: 'recDiagnostics',
  label: 'REC Menu',
};

const epiUtilitiesPermission = {
  id: 'epiUtilitiesPermission',
  label: 'EPI Utilities',
};
const orderBtnOobm = {
  id: 'orderBtnOobm',
  label: 'Order BTN',
};
const OobmAccess = {
  id: 'OobmAccess',
  label: 'OOBM Assignment',
};
const boxToBoxHuntConfiguration = {
  id: 'boxToBoxHuntConfiguration',
  label: 'Box To Box Hunt Configuration',
};
const cellSignalCheck = {
  id: 'cellSignalCheck',
  label: 'Cell Signal Check',
};
const engineeringLock = {
  id: 'engineeringLock',
  label: 'Engineering Lock',
};

const omitLeading = {
  id: 'omitLeading',
  label: 'Omit 9',
};

const registrationOffSet = {
  id: 'registrationOffSet',
  label: 'Registration Offset',
};

const dataCenter = {
  id: 'dataCenter',
  label: 'Data Center Registration',
};

const callWaiting = {
  id: 'callWaiting',
  label: 'Call Waiting',
};

const powerSave = {
  id: 'powerSave',
  label: 'Power Save',
};

const deleteEpi = {
  id: 'deleteEpi',
  label: 'Delete EPI',
};

const cancelIntegrationAccess = {
  id: 'cancelIntegrationAccess',
  label: 'Integration',
};

const modifyEPIS = {
  id: 'modifyEPIS',
  label: 'Modify EPI’s',
};

const enableMonitoring = {
  id: 'enableMonitoring',
  label: 'Device Monitoring',
};

const callerIdMaskingAccess = {
  id: 'callerIdMaskingAccess',
  label: 'Caller ID Masking',
};

const eventsAccess = {
  id: 'eventsAccess',
  label: 'Events',
};

const epikUpdates = {
  id: 'epikUpdates',
  label: 'Epik Updates',
};

const enhancedAnalyzer = {
  id: 'enhancedAnalyzer',
  label: 'Enhanced Analyzer',
};

const enableAlarmProtocol = {
  id: 'enableAlarmProtocol',
  label: 'Enable Alarm Protocol Relay',
};

const epiFirmwareUpdate = {
  id: 'epiFirmwareUpdate',
  label: 'EPI Firmware Update',
};

const tcToolsAccess = {
  id: 'tcToolsAccess',
  label: 'Tc Tools',
};

const nocLogsAccess = {
  id: 'nocLogsAccess',
  label: 'NOC Logs',
};

const deviceHistoricalData = {
  id: 'deviceHistoricalData',
  label: 'Device Historical Data',
};

const edgmonpermission = {
  id: 'edgmonpermission',
  label: 'Edge Monitor',
};

const epikEngineering = {
  id: 'epikEngineering',
  label: 'Epik Engineering Toggle',
};

const batteryReplacedOn = {
  id: 'batteryReplacedOn',
  label: 'Battery Replaced On',
};

const secondaryNotification = {
  id: 'secondaryNotification',
  label: 'Secondary Notification',
};

const secureInfo = {
  id: 'secureInfo',
  label: 'Secure Info',
};

const enableDisablePort = {
  id: 'enableDisablePort',
  label: 'Enable Disable Port',
};

const outboundOverride = {
  id: 'outboundOverride',
  label: 'Outbound Override',
};

const trunkSelection = {
  id: 'trunkSelection',
  label: 'Trunk Selection',
};

const deleteCompany = {
  id: 'deleteCompany',
  label: 'Delete Company',
};
const resetToDefault = {
  id: 'resetToDefault',
  label: 'Reset to Default',
};
const disableOobmTerminal = {
  id: 'disableOobmTerminal',
  label: 'Disable OOBM Portal Terminal Emulator',
};
const failOverOptions = {
  id: 'failOverOptions',
  label: 'Failover Options',
};
const bulkUserUpload = {
  id: 'bulkUserUpload',
  label: 'Bulk Account Add',
};
const deleteCompanyGroup = {
  id: 'deleteCompanyGroup',
  label: 'Delete Company Group',
};
const deleteEnterpriseGroup = {
  id: 'deleteEnterpriseGroup',
  label: 'Delete Enterprise Group',
};
const deleteNumber = {
  id: 'deleteNumber',
  label: 'Delete Number',
};
const callFeatures = {
  id: 'callFeatures',
  label: 'Call Features',
};
const customTemplate = {
  id: 'customTemplate',
  label: 'Custom Template',
};
const wikiAccess = {
  id: 'wikiAccess',
  label: 'Wiki Access',
};
const outboundLowMTU = {
  id: 'outboundLowMTU',
  label: 'Outbound Low MTU',
};

const threeWayCalling = {
  id: 'threeWayCalling',
  label: '3 Way Calling',
};const callTransfer = {
  id: 'callTransfer',
  label: 'Call Transfer',
};
const callForwardBusy = {
  id: 'callForwardBusy',
  label: 'Call Forward Busy',
};
const callForwardNoAnswer = {
  id: 'callForwardNoAnswer',
  label: 'all Forward No-Answer',
};
const callForwardAlways = {
  id: 'callForwardAlways',
  label: 'Call Forward Always',
};
const remoteCallForward = {
  id: 'remoteCallForward',
  label: 'Remote Call Forwarding',
};
const callRejection = {
  id: 'callRejection',
  label: 'Anonymous Call Rejection',
};
const callBlocking = {
  id: 'callBlocking',
  label: 'Call Blocking',
};
const doNotDisturb = {
  id: 'doNotDisturb',
  label: 'Do Not Disturb',
};
const demoBox = {
  id: 'demoBox',
  label: 'Enable Demo Box',
};
const newNumber = {
  id: 'newNumber',
  label: 'New Number',
}

const numberForceUnlink = {
  id: 'numberForceUnlink',
  label: 'Number Force Unlink / Unassign',
};

const activeEdgeDevice = {
  id: 'activeEdgeDevice',
  label: 'Active Edge Device',
};
export const allPermissionsListWithLabel = {
  portingAccessEnabled,
  dataCenterMonitor,
  warehouseQcAccess,
  eth3Access,
  pcapModulePermission,
  portConfigurationAccess,
  engineeringLock,
  registrationOffSet,
  dataCenter,
  powerSave,
  cancelIntegrationAccess,
  realTimeActivityEnabled,
  numberCarrierChangeAccess,
  nocWizardAccess,
  phoneAccess,
  internationalDialingAccess,
  recDiagnostics,
  omitLeading,
  outBandManagement,
  ttyOptionsAccess,
  callWaiting,
  deleteEpi,
  modifyEPIS,
  numberBulkActionsAccess,
  epiUtilitiesPermission,
  callerIdMaskingAccess,
  enableMonitoring,
  eventsAccess,
  epikUpdates,
  enableAlarmProtocol,
  enhancedAnalyzer,
  epiFirmwareUpdate,
  docToolAccess,
  tcToolsAccess,
  nocLogsAccess,
  deviceHistoricalData,
  edgmonpermission,
  orderBtnOobm,
  OobmAccess,
  cellSignalCheck,
  batteryReplacedOn,
  secondaryNotification,
  secureInfo,
  enableDisablePort,
  outboundOverride,
  trunkSelection,
  deleteCompany,
  resetToDefault,
  disableOobmTerminal,
  failOverOptions,
  bulkUserUpload,
  deleteCompanyGroup,
  deleteEnterpriseGroup,
  deleteNumber,
  callFeatures,
  wikiAccess,
  outboundLowMTU,
  epikPlatform,
  threeWayCalling,
  callTransfer,
  callForwardBusy,
  callForwardNoAnswer,
  callForwardAlways,
  remoteCallForward,
  callRejection,
  callBlocking,
  doNotDisturb,
  demoBox,
  newNumber,
  numberForceUnlink,
  activeEdgeDevice,
  customTemplate,
  boxToBoxHuntConfiguration
}

export const permissions = [
  {
    id: 'portAccess',
    label: 'Carrier Hub: Porting',
    checked: 'portingAccessEnabled',
    onChange: 'handleToggleChange',
    condition: '!hiddenCarrier()',
    disabledCondition: 'userRole !== "superAdmin"',
  },
  {
    id: 'realTimeActivityEnabled',
    label: 'PCAP Analyzer',
    checked: 'realTimeActivityEnabled',
    onChange: 'handleToggleChange',
    condition: '!hiddenCarrier()',
  },
  {
    id: 'dataCenterMonitor',
    label: 'Data Center Monitor',
    checked: 'dataCenterMonitor',
    onChange: 'handleToggleChange',
    condition:'userRole === "superAdmin" && role === "superAdmin" || user.epikEngineering === true',
  },
  {
    id: 'numberCarrierChangeAccess',
    label: 'Carrier Access',
    checked: 'numberCarrierChangeAccess',
    onChange: 'handleToggleChange',
    condition: 'userRole === "superAdmin" && role === "superAdmin"',
    disabledCondition: 'userRole !== "superAdmin"',
  },
  {
    id: 'warehouseQcAccess',
    label: 'Warehouse QC Wizard',
    checked: 'warehouseQcAccess',
    onChange: 'handleToggleChange',
    condition: 'isUserAllowedToUnlockAccount()',
  },
  {
    id: 'nocWizardAccess',
    label: 'NOC Wizard',
    checked: 'nocWizardAccess',
    onChange: 'handleToggleChange',
    condition: 'isUserAllowedToUnlockAccount()',
  },
  {
    id: 'numberBulkActionsAccess',
    label: 'Number Bulk Actions',
    checked: 'numberBulkActionsAccess',
    onChange: 'handleToggleChange',
    condition:
      '(userRole === "superAdmin" || userRole === "companyGroupAdmin") && (role === "superAdmin" || role === "companyGroupAdmin")',
    disabledCondition: 'userRole !== "superAdmin"',
  },
  {
    id: 'eth3Access',
    label: 'Eth0/3 Disable',
    checked: 'eth3Access',
    onChange: 'handleToggleChange',
    condition: 'userRole === "superAdmin" || role === "companyGroupAdmin"', // Both can see the toggle
    disabledCondition: 'userRole !== "superAdmin"',
  },
  {
    id: 'phoneAccess',
    label: 'IP Phone Management',
    checked: 'phoneAccess',
    onChange: 'handleToggleChange',
    condition: '!hiddenCarrier()',
  },
  {
    id: 'pcapModulePermission',
    label: 'PCAP Lookup',
    checked: 'pcapModulePermission',
    onChange: 'handleToggleChange',
    condition: 'isUserAllowedToUnlockAccount()',
  },
  {
    id: 'internationalDialingAccess',
    label: 'International Dialing',
    checked: 'internationalDialingAccess',
    onChange: 'handleToggleChange',
    condition: 'isUserAllowedToUnlockAccount()',
  },
  {
    id: 'outBandManagement',
    label: 'OOBM',
    checked: 'outBandManagement',
    onChange: 'handleToggleChange',
    condition: 'userRole === "superAdmin" || role === "companyGroupAdmin"',
    disabledCondition: 'userRole !== "superAdmin"',
    style: { marginLeft: '20px' },
  },
  {
    id: 'portConfigurationAccess',
    label: 'Port Configuration management',
    checked: 'portConfigurationAccess',
    onChange: 'handleToggleChange',
    condition: 'isUserAllowedToUnlockAccount()',
  },
  {
    id: 'ttyOptionsAccess',
    label: 'TTY Access Management',
    checked: 'ttyOptionsAccess',
    onChange: 'handleToggleChange',
    disabledCondition: `!['companyGroupAdmin', 'superAdmin'].includes(userRole) || !updateUser.ttyOptionsAccess`,
    condition:
      '(hasOobBox || ["companyGroupAdmin", "superAdmin"].includes(userRole) && ["companyGroupAdmin", "superAdmin", "admin"].includes(role))',
  },
  {
    id: 'docToolAccess',
    label: 'Documentation Tool',
    checked: 'docToolAccess',
    onChange: 'handleToggleChange',
    disabledCondition: '!isUserAllowedToUnlockAccount()',
    condition: `(role !== 'superAdmin' && role !== 'companyGroupAdmin') && isUserAllowedToUnlockAccount()`,
    style: { marginLeft: '20px' },
  },
  {
    id: 'recDiagnostics',
    label: 'REC Menu',
    checked: 'recDiagnostics',
    onChange: 'handleToggleChange',
    condition: 'userRole === "superAdmin"',
    disabledCondition: 'userRole !== "superAdmin"',
    style: { marginLeft: '20px' },
  },
  {
    id: 'epiUtilities',
    label: 'EPI Utilities',
    checked: 'epiUtilitiesPermission',
    onChange: 'handleToggleChange',
    condition: 'userRole === "superAdmin" || role === "companyGroupAdmin"',
    disabledCondition: 'userRole !== "superAdmin" && role !== "companyGroupAdmin"',
    style: { marginLeft: '20px' },
  },
  {
    id: 'engineeringLock',
    label: 'Engineering Lock',
    checked: 'engineeringLock',
    onChange: 'handleToggleChange',
    condition: 'userRole === "superAdmin" || role === "companyGroupAdmin"',
    disabledCondition: 'userRole !== "superAdmin"',
    style: { marginLeft: '20px' },
  },
  {
    id: 'omitLeading',
    label: 'Omit 9',
    checked: 'omitLeading',
    onChange: 'handleToggleChange',
    condition: 'userRole === "superAdmin" || role === "companyGroupAdmin"',
    disabledCondition: 'userRole !== "superAdmin"',
    style: { marginLeft: '20px' },
  },
  {
    id: 'registrationOffSet',
    label: 'Registration Offset',
    checked: 'registrationOffSet',
    onChange: 'handleToggleChange',
    condition: 'userRole === "superAdmin" || role === "companyGroupAdmin"', // Both can see the toggle
    disabledCondition: 'userRole !== "superAdmin"',
    style: { marginLeft: '20px' },
  },
  {
    id: 'dataCenter',
    label: 'Data Center Registration',
    checked: 'dataCenter',
    onChange: 'handleToggleChange',
    condition: 'userRole === "superAdmin" || role === "companyGroupAdmin"', // Both can see the toggle
    disabledCondition: `userRole !== 'superAdmin'`, // Disable for non-superAdmin users
    style: { marginLeft: '20px' },
  },
  {
    id: 'callWaiting',
    label: 'Call Waiting',
    checked: 'callWaiting',
    onChange: 'handleToggleChange',
    condition: 'userRole === "superAdmin" || role === "companyGroupAdmin"', // Both can see the toggle
    disabledCondition: 'userRole !== "superAdmin"',
    style: { marginLeft: '20px' },
  },
  {
    id: 'powerSave',
    label: 'Power Save',
    checked: 'powerSave',
    onChange: 'handleToggleChange',
    condition: 'userRole === "superAdmin" || role === "companyGroupAdmin"', // Both can see the toggle
    disabledCondition: 'userRole !== "superAdmin"',
    style: { marginLeft: '20px' },
  },
  {
    id: 'deleteEpi',
    label: 'Delete EPI',
    checked: 'deleteEpi',
    onChange: 'handleToggleChange',
    condition: 'userRole === "superAdmin" || role === "companyGroupAdmin"', // Both can see the toggle
    disabled: `userRole !== 'superAdmin'`, // Disable for non-superAdmin users
    style: { marginLeft: '20px' },
  },
  {
    id: 'cancelIntegrationAccess',
    label: 'Integration',
    checked: 'cancelIntegrationAccess',
    onChange: 'handleToggleChange',
    condition: 'userRole === "superAdmin" || role === "companyGroupAdmin"', // Both can see the toggle
    disabled: `userRole !== 'superAdmin'`, // Disable for non-superAdmin users
    style: { marginLeft: '20px' },
  },
  {
    id: 'modifyEPIS',
    label: 'Modify EPI’s',
    checked: 'modifyEPIS',
    onChange: 'handleToggleChange',
    condition: 'userRole === "superAdmin" || role === "companyGroupAdmin"',
    disabledCondition: 'userRole !== "superAdmin"',
    style: { marginLeft: '20px' },
  },
  {
    id: 'enableMonitoring',
    label: 'Device Monitoring',
    checked: 'enableMonitoring',
    onChange: 'handleToggleChange',
    condition: 'userRole === "superAdmin" || role === "companyGroupAdmin"', // Both can see the toggle
    disabled: `userRole !== 'superAdmin'`, // Disable for non-superAdmin users
    style: { marginLeft: '20px' },
  },
  {
    id: 'callerIdMaskingAccess',
    label: 'Caller ID Masking',
    checked: 'callerIdMaskingAccess',
    onChange: 'handleToggleChange',  
    condition: `role === 'superAdmin' && userRole === "superAdmin" && user.epikEngineering === true`,  
    style: { marginLeft: '20px' }
  },
  {
    id: 'eventsAccess',
    label: 'Events',
    checked: 'eventsAccess',
    onChange: 'handleToggleChange',  
    condition: `role === 'superAdmin' && userRole === "superAdmin" && user.epikEngineering === true`,  
    style: { marginLeft: '20px' }
  },
  {
    id: 'epikUpdates',
    label: 'Epik Updates',
    checked: 'epikUpdates',
    onChange: 'handleToggleChange',  
    condition: `role === 'superAdmin' && userRole === "superAdmin" && user.epikEngineering === true`,  
    style: { marginLeft: '20px' }
  },
  {
    id: 'enhancedAnalyzer',
    label: 'Enhanced Analyzer',
    checked: 'enhancedAnalyzer',
    onChange: 'handleToggleChange',  
    condition: `user.epikEngineering === true`,  
    style: { marginLeft: '20px' }
  },
  {
    id: 'enableAlarmProtocol',
    label: 'Enable Alarm Protocol Relay',
    checked: 'enableAlarmProtocol',
    onChange: 'handleToggleChange',  
    condition: `role === 'superAdmin' || userRole === "superAdmin" || user.epikEngineering === true`,  
    style: { marginLeft: '20px' }
  }, 
  {
    id: 'epiFirmwareUpdate',
    label: 'EPI Firmware Update',
    checked: 'epiFirmwareUpdate',
    onChange: 'handleToggleChange',  
    condition: `role === 'superAdmin' || userRole === "superAdmin" || user.epikEngineering === true`,  
    style: { marginLeft: '20px' }
  },
  {
    id: 'tcToolsAccess',
    label: 'Tc Tools',
    checked: 'tcToolsAccess',
    onChange: 'handleToggleChange',  
    condition: `user.epikEngineering === true`,  
    style: { marginLeft: '20px' }
  },
  {
    id: 'nocLogsAccess',
    label: 'NOC Logs',
    checked: 'nocLogsAccess',
    onChange: 'handleToggleChange',  
    condition: `isUserAllowedToUnlockAccount()`,  
    style: { marginLeft: '20px' }
  },
  {
    id: 'batteryReplacedOn',
    label: 'Battery Replaced On',
    checked: 'batteryReplacedOn',
    onChange: 'handleToggleChange',  
    condition: `role === 'superAdmin' && userRole === "superAdmin" && user.epikEngineering === true`,  
    style: { marginLeft: '20px' }
  },
  {
    id: 'secondaryNotification',
    label: 'Secondary Notification',
    checked: 'secondaryNotification',
    onChange: 'handleToggleChange',
    condition: `role === 'superAdmin' && userRole === "superAdmin" && user.epikEngineering === true`,
    style: { marginLeft: '20px' }
  },
  {
    id: 'secureInfo',
    label: 'Secure Info',
    checked: 'secureInfo',
    onChange: 'handleToggleChange',  
    condition: `role === 'superAdmin' && userRole === "superAdmin" && user.epikEngineering === true`,  
    style: { marginLeft: '20px' }
  },
  {
    id: 'enableDisablePort',
    label: 'Enable Disable Port',
    checked: 'enableDisablePort',
    onChange: 'handleToggleChange',  
    condition: `role === 'superAdmin' && userRole === "superAdmin" && user.epikEngineering === true`,  
    style: { marginLeft: '20px' }
  },
  {
    id: 'outboundOverride',
    label: 'Outbound Override',
    checked: 'outboundOverride',
    onChange: 'handleToggleChange',  
    condition: `role === 'superAdmin' && userRole === "superAdmin" && user.epikEngineering === true`,  
    style: { marginLeft: '20px' }
  },
  {
    id: 'trunkSelection',
    label: 'Trunk Selection',
    checked: 'trunkSelection',
    onChange: 'handleToggleChange',  
    condition: `role === 'superAdmin' && userRole === "superAdmin" && user.epikEngineering === true`,  
    style: { marginLeft: '20px' }
  },
  {
    id: 'deleteCompany',
    label: 'Delete Company',
    checked: 'deleteCompany',
    onChange: 'handleToggleChange',  
    condition: `role === 'superAdmin' && userRole === "superAdmin" && user.epikEngineering === true`,  
    style: { marginLeft: '20px' }
  },
];

export const userPermissions = [
  {
    id: 'lockReminder',
    label: 'Ignore device lock messages',
    checked: 'lockReminder',
    onChange: 'handleToggleChange',
  },
  {
    id: 'systemServiceAccount',
    label: 'System Service Account',
    checked: 'deleteLock',
    onChange: 'handleToggleChange',
    condition: 'userRole === "superAdmin"',
  },
  {
    id: 'accountLocked',
    label: 'Account Locked',
    checked: 'accountLocked',
    onChange: 'handleToggleChange',
    condition: 'isUserAllowedToUnlockAccount()',
  },
  {
    id: 'isAccountApprover',
    label: 'User Account Approver',
    checked: 'isAccountApprover',
    onChange: 'handleToggleChange',
    condition: `userRole === "superAdmin" || user.isAccountApprover === true`,
    disabledCondition: '!(userRole === "superAdmin" || user.epikEngineering === true)',
  },
  {
    id: 'epikEngineering',
    label: 'EPIK Engineering',
    checked: 'epikEngineering',
    onChange: 'handleToggleChange',
    condition: `user.epikEngineering === true && ( role === 'superAdmin' && userRole === "superAdmin")`,
  },
  {
    id: 'manager',
    label: 'Manager',
    checked: 'manager',
    onChange: 'handleToggleChange',
    condition: `user.epikEngineering === true || updateUser.manager === true `,
  },
  {
    id: 'oobmnEdpointAssignment',
    label: 'OOBM Endpoint Assignment',
    checked: 'oobmnEdpointAssignment',
    onChange: 'handleToggleChange',
    condition: `user.epikEngineering === true || ( role === 'superAdmin' && userRole === "superAdmin" ||  role === 'companyGroupAdmin' && userRole === "companyGroupAdmin")`,
  },
];


export const categorziedPermissions = {
  OutOfBandManagement: [
    "outBandManagement",
    "ttyOptionsAccess",
    "orderBtnOobm",
    "OobmAccess",
    "disableOobmTerminal"
  ],
  SystemTools: [
    "docToolAccess",
    "tcToolsAccess",
    "nocLogsAccess",
    "recDiagnostics",
    "warehouseQcAccess",
    "bulkUserUpload",
    "numberBulkActionsAccess",
    "deleteCompanyGroup",
    "deleteEnterpriseGroup",
    "deleteNumber",
    "wikiAccess",
    "demoBox"
  ],
  EdgeDeviceManagement: [
    "portingAccessEnabled",
    "dataCenterMonitor",
    "pcapModulePermission",
    "portConfigurationAccess",
    "engineeringLock",
    "registrationOffSet",
    "dataCenter",
    "powerSave",
    "cancelIntegrationAccess",
    "realTimeActivityEnabled",
    "numberCarrierChangeAccess",
    "nocWizardAccess",
    "phoneAccess",
    "internationalDialingAccess",
    "omitLeading",
    "callWaiting",
    "deleteEpi",
    "modifyEPIS",
    "epiUtilitiesPermission",
    "callerIdMaskingAccess",
    "enableMonitoring",
    "eventsAccess",
    "epikUpdates",
    "enableAlarmProtocol",
    "enhancedAnalyzer",
    "epiFirmwareUpdate",
    "eth3Access",
    "deviceHistoricalData",
    "edgmonpermission",
    "resetToDefault",
    "trunkSelection",
    "batteryReplacedOn",
    "secondaryNotification",
    "enableDisablePort",
    "outboundOverride",
    "deleteCompany",
    "secureInfo",
    "failOverOptions",
    "outboundLowMTU",
    "callFeatures",
    "epikPlatform",
    "newNumber",
    "numberForceUnlink",
    "activeEdgeDevice",
    "customTemplate",
    "cellSignalCheck",
    "boxToBoxHuntConfiguration"
  ]
}